<template>
	<div class="page-404">
		<div class="middle-box">
			<div>
				<h3>
					<img :src="logo" />
				</h3>
				<p>抱歉，您访问的页面没有找到，请检查地址是否正确</p>
				<h4>
					<small>{{ second }}秒后自动返回登录页</small>
				</h4>
				<div class="align-center" style="padding-top: 30px">
					<a href="" @click.prevent="home">返回登录页</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import logo from './404.png';
export default {
	name: 'NotFound',
	data() {
		return {
			logo,
			second: 5
		};
	},
	created() {
		let counter = setInterval(() => {
			this.second--;
			if (this.second === 1) {
				clearInterval(counter);
				this.home();
			}
		}, 1000);
	},
	methods: {
		home() {
			this.$router.push('/login');
		}
	}
};
</script>

<style lang="less">
.page-404 {
	height: 100%;
	-webkit-box-flex: 1;
	-ms-flex-positive: 1;
	flex-grow: 1;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	height: 100%;
	overflow: auto;
	.middle-box {
		max-width: 700px;
		margin: 0 auto;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
	}
	.align-center {
		text-align: center;
	}
	p {
		padding: 15px;
	}
	h2.main-title {
		color: #bbb;
		padding-top: 60px;
	}
	h3 {
		margin-bottom: 30px;
		img {
			width: 100%;
		}
	}
	h4 {
		padding: 10px;
		small {
			color: #999;
		}
	}
}
</style>
